module.exports = __webpack_public_path__ + "img/1509836398.23f43827.jpg";